import { useEffect } from 'react';
import { useSubstate } from 'use-substate';

import { client, useErrorNotifications } from 'core/http';
import { SetLocations } from 'core/Store/locations/actions';
import { selectLocations } from 'core/Store/locations/selectors';
import { Location } from 'core/types/location';

export default function useLocations() {
  const showErrorNotification = useErrorNotifications();
  const [locations, dispatch] = useSubstate(selectLocations);

  useEffect(() => {
    if (locations.length) {
      return;
    }

    client()
      .get<Location[]>('locations')
      .then(response => dispatch(new SetLocations(response.data)))
      .catch(showErrorNotification);
  }, [dispatch, locations, showErrorNotification]);

  return locations;
}
